import { render, staticRenderFns } from "./InstallGbwhatsapp.vue?vue&type=template&id=5106f4db"
import script from "./InstallGbwhatsapp.vue?vue&type=script&lang=js"
export * from "./InstallGbwhatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports